import { render, staticRenderFns } from "./HomePageFooter.vue?vue&type=template&id=0865da1e&scoped=true&"
import script from "./HomePageFooter.vue?vue&type=script&lang=js&"
export * from "./HomePageFooter.vue?vue&type=script&lang=js&"
import style0 from "./HomePageFooter.vue?vue&type=style&index=0&id=0865da1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0865da1e",
  null
  
)

export default component.exports